import mutations from './mutations';
import actions from './actions';
import getters from './getters';
import { defaultMetricsFilters } from './actions';

const state = {
  filters: defaultMetricsFilters(),
  overview: null,
  funnel: null,
  rankings: null,
  distribution: null,
  syncStatus: { loading: false, lastSync: null, error: null },
  uiFlags: {
    isLoadingOverview: false,
    isLoadingFunnel: false,
    isLoadingRankings: false,
  },
  // incrementados a cada fetch — usados para descartar respostas de
  // requisições antigas que chegam fora de ordem após um filtro novo já
  // ter sido aplicado (ver actions.js).
  requestIds: {
    overview: 0,
    funnel: 0,
    rankings: 0,
    distribution: 0,
  },
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};
